import { Link } from "react-router";
import { generateMetaTags, SITE_URL } from "~/lib/seo";

export function meta() {
	return generateMetaTags({
		title: "Zásady cookies – FirmIndex",
		description:
			"Informace o používání cookies na webu FirmIndex. Zjistěte, jaké cookies používáme a jak je spravovat.",
		canonical: `${SITE_URL}/cookie-policy`,
	});
}

export default function CookiePolicy() {
	return (
		<section className="px-6 py-16 lg:px-8 lg:py-24">
			<article className="glass-panel-strong prose prose-gray mx-auto max-w-3xl rounded-3xl p-6 sm:p-10">
				<h1 className="text-4xl font-extrabold tracking-tight text-text">Zásady cookies</h1>
				<p className="mt-2 text-sm text-muted">Poslední aktualizace: 14. března 2026</p>

				<div className="mt-12 flex flex-col gap-8 text-sm leading-relaxed text-muted">
					<section>
						<h2 className="text-xl font-bold text-text">1. Co jsou cookies</h2>
						<p>
							Cookies jsou malé textové soubory, které se ukládají ve vašem prohlížeči při návštěvě
							webových stránek. Slouží k zapamatování vašich preferencí, zajištění správného
							fungování webu a v některých případech k analýze návštěvnosti.
						</p>
					</section>

					<section>
						<h2 className="text-xl font-bold text-text">2. Jaké cookies používáme</h2>
						<div className="overflow-x-auto">
							<table className="mt-4 w-full text-left text-sm">
								<thead>
									<tr className="border-b">
										<th className="pb-2 pr-4 font-semibold">Název</th>
										<th className="pb-2 pr-4 font-semibold">Typ</th>
										<th className="pb-2 pr-4 font-semibold">Účel</th>
										<th className="pb-2 font-semibold">Platnost</th>
									</tr>
								</thead>
								<tbody className="divide-y">
									<tr>
										<td className="py-2 pr-4">
											<code className="text-xs">firmindex_cookie_consent</code>
										</td>
										<td className="py-2 pr-4">Funkční</td>
										<td className="py-2 pr-4">Uložení vašeho souhlasu s cookies</td>
										<td className="py-2">1 rok</td>
									</tr>
									<tr>
										<td className="py-2 pr-4">
											<code className="text-xs">sb-*</code>
										</td>
										<td className="py-2 pr-4">Nezbytné</td>
										<td className="py-2 pr-4">Autentizace uživatele (Supabase)</td>
										<td className="py-2">Relace / 7 dní</td>
									</tr>
									<tr>
										<td className="py-2 pr-4">
											<code className="text-xs">_ga</code>
										</td>
										<td className="py-2 pr-4">Analytické</td>
										<td className="py-2 pr-4">Rozlišení uživatelů (Google Analytics 4)</td>
										<td className="py-2">2 roky</td>
									</tr>
									<tr>
										<td className="py-2 pr-4">
											<code className="text-xs">_ga_*</code>
										</td>
										<td className="py-2 pr-4">Analytické</td>
										<td className="py-2 pr-4">Uchování stavu relace (Google Analytics 4)</td>
										<td className="py-2">2 roky</td>
									</tr>
								</tbody>
							</table>
						</div>
					</section>

					<section>
						<h2 className="text-xl font-bold text-text">3. Analytické cookies (GA4)</h2>
						<p>
							Pro analýzu návštěvnosti používáme Google Analytics 4. Analytické cookies (_ga, _ga_*)
							se aktivují pouze s vaším výslovným souhlasem. Bez souhlasu GA4 neukládá žádné cookies
							a nesbírá identifikovatelná data.
						</p>
						<p>
							Data mohou být přenášena do USA na základě standardních smluvních doložek EU. Zásady
							ochrany soukromí Google naleznete na{" "}
							<a
								href="https://policies.google.com/privacy"
								target="_blank"
								rel="noopener noreferrer"
								className="underline hover:text-primary"
							>
								policies.google.com/privacy
							</a>
							.
						</p>
					</section>

					<section>
						<h2 className="text-xl font-bold text-text">4. Jak spravovat cookies</h2>
						<p>
							Při první návštěvě webu se vám zobrazí lišta, kde můžete cookies přijmout nebo
							odmítnout. Své rozhodnutí můžete kdykoliv změnit smazáním dat v nastavení prohlížeče.
						</p>
						<p>
							Většina prohlížečů také umožňuje spravovat cookies přímo v nastavení — můžete je
							blokovat, mazat nebo nastavit výjimky pro konkrétní weby.
						</p>
					</section>

					<section>
						<h2 className="text-xl font-bold text-text">5. Kontakt</h2>
						<p>
							Máte-li dotazy ohledně cookies nebo ochrany soukromí, kontaktujte nás na{" "}
							<a href="mailto:privacy@firmindex.cz" className="underline hover:text-primary">
								privacy@firmindex.cz
							</a>
							.
						</p>
						<p className="mt-2">
							Další informace o ochraně osobních údajů najdete v{" "}
							<Link to="/ochrana-soukromi" className="underline hover:text-primary">
								Zásadách ochrany soukromí
							</Link>
							.
						</p>
					</section>
				</div>
			</article>
		</section>
	);
}
